<template>
  <div class="chart-editor">
    <div
      class="chart-editor__editor">

      <div class="chart-editor__chart-container">
        <div
          v-if="hasErrors"
          class="chart-editor__chart-errors mb-16">
          <ChartErrors />
        </div>

        <div
          class="chart-editor__chart"
          v-if="type === 'line'">
          <LineChart />
        </div>
        <div
          class="chart-editor__chart"
          v-else-if="type === 'bar'">
          <BarChart />
        </div>
        <div
          class="chart-editor__chart"
          v-else-if="type === 'pie'">
          <PieChart />
        </div>
        <div
          class="chart-editor__chart"
          v-else-if="type === 'table'">
          <TableChart />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "components/chart/charts/bar-chart";
import LineChart from "components/chart/charts/line-chart";
import PieChart from "components/chart/charts/pie-chart";
import TableChart from "components/chart/charts/table-chart";
import ChartErrors from "components/chart/charts/chart-errors";

import { mapGetters } from "vuex";

export default {
  components: {
    BarChart,
    LineChart,
    PieChart,
    TableChart,
    ChartErrors
  },
  computed: {
    ...mapGetters("chart", ["fields", "result", "type", "hasErrors"])
  },
  data() {
    return {
      chart: null
    }
  }
};
</script>

<style lang="scss">
.chart-editor {
  &__chart-canvas {
    width: 100%;
    height: 600px;
  }

  &__editor {
    display: flex;
  }

  &__config {
    width: 30%;
    flex-shrink: 0;
    min-width: $px320;
  }

  &__chart-container {
    width: 100%;
  }
}
</style>
